<template lang="pug">
.group-title-wrapper
    h2.group-title {{title}}
    span.tip(v-if="tip") {{tip}}
</template>
<script>
export default {
    name: 'group-title',
    props: ['title', 'tip']
};
</script>
<style lang="sass" scoped>
.group-title-wrapper
    display: flex
    justify-content: space-between
    align-items: center
    height: 16px
    line-height: 16px
    .group-title
        padding-left: 16px
        font-family: PingFangSC-Semibold
        font-size: 16px
        color: #333333
        background: url(~public/images/gzzoc/title-bg.svg) no-repeat left top / 8px 16px
    .tip
        padding-left: 24px
        font-family: PingFangSC-Regular
        font-size: 14px
        color: #999999
        text-align: right
        background: url(~public/images/gzzoc/info.svg) no-repeat left top / 16px 16px
</style>
